"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlackOilModalComponent = void 0;
var core_1 = require("@angular/core");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var _services_1 = require("@/_services");
var platform_browser_1 = require("@angular/platform-browser");
var BlackOilModalComponent = /** @class */ (function () {
    function BlackOilModalComponent(activeModal, sanitizer, authenticationService) {
        this.activeModal = activeModal;
        this.sanitizer = sanitizer;
        this.authenticationService = authenticationService;
        this.get_gcdm_config = this.authenticationService.get_config();
        this.motorPlanHost = process.env.motorplan_host;
    }
    BlackOilModalComponent.prototype.ngOnInit = function () {
        var url = this.get_gcdm_config['Black_oil_form'];
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], BlackOilModalComponent.prototype, "my_modal_title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], BlackOilModalComponent.prototype, "vehicleMotorplan", void 0);
    BlackOilModalComponent = __decorate([
        core_1.Component({
            selector: 'blackoilmodal',
            template: require('./blackoilmodal.component.html')
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
            platform_browser_1.DomSanitizer,
            _services_1.AuthenticationService])
    ], BlackOilModalComponent);
    return BlackOilModalComponent;
}());
exports.BlackOilModalComponent = BlackOilModalComponent;
